<div class="message-no-data">
  <p>{{message}}</p>
</div>
